import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1,Text4 } from '../../../styles';
import ReCAPTCHA from 'react-google-recaptcha';

const recaptchaRef = React.createRef()


const ResendPasswordModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Resend Password
            </Text1>
        )
    };

    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={() => props.toggleResendPasswordModal()}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Ld6bTgUAAAAAA6oCjg5ABKApovAVcIBARo2Neri"
                onChange={() => props.onCaptchaVerify()}
            />
        </EaseModal>
    )
};

export { ResendPasswordModal };